import React, { useState, useEffect } from 'react';
import { useViewMode } from '../hooks/useViewMode';
import { dashboardAPI } from '../services/api';
import DashboardLayout from '../components/Layout/DashboardLayout';
import Dashboard from './Dashboard';
import dayjs from 'dayjs';

const DashboardWrapper: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [period, setPeriod] = useState('week');
  const [dateRange, setDateRange] = useState<[dayjs.Dayjs | null, dayjs.Dayjs | null] | null>(null);
  const { isMobile } = useViewMode();

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const params: any = { period };
      if (dateRange && dateRange[0] && dateRange[1]) {
        params.start_date = dateRange[0].format('YYYY-MM-DD');
        params.end_date = dateRange[1].format('YYYY-MM-DD');
      }
      
      await dashboardAPI.getOverview(params);
      // Trigger Dashboard component to refetch data
      window.dispatchEvent(new CustomEvent('dashboard-refresh'));
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout 
      onRefresh={isMobile ? fetchDashboardData : undefined}
      refreshLoading={loading}
    >
      <Dashboard />
    </DashboardLayout>
  );
};

export default DashboardWrapper;